import ApiService from "./api.service";

export default {
  getAudits(id, opcoes = { showOverlay: true }) {
    return ApiService.get("/meta-templates-logs", id, opcoes["showOverlay"]);
  },
  getTemplates(contasId = [], opcoes = { showOverlay: true }) {
    return ApiService.get("/template", null, opcoes["showOverlay"], {
      params: { conta_id: contasId }
    });
  }
};
